import * as PRODUCT_ONBOARDING from "constants/productOnboardings";
import { ONBOARDING_STATUS_COMPLETED } from "constants/productOnboardingStatus";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useGetOnboardingProductsQuery } from "store/apis/productOnboarding";
import { type ONBOARDING_PRODUCTS } from "types/contants/onboardingProducts";

type OnboardingProfile = {
  isProfileIncomplete: boolean;
  progress: number;
  productName?: ONBOARDING_PRODUCTS;
};

export const useOnboardingProfile = (): OnboardingProfile => {
  const { uuid: groupId } = useCurrentGroupContext();

  const { data: products } = useGetOnboardingProductsQuery(
    { groupId },
    { skip: !groupId }
  );

  const platformOnboarding = products?.find(
    (product) =>
      product.name === PRODUCT_ONBOARDING.TAX ||
      product.name === PRODUCT_ONBOARDING.TAXV2
  );

  return {
    isProfileIncomplete: Boolean(
      platformOnboarding &&
        platformOnboarding.status !== ONBOARDING_STATUS_COMPLETED
    ),
    progress: platformOnboarding?.progress ?? 0,
    productName: platformOnboarding?.name,
  };
};
